import MultiSelectList from 'component/atom/forms/select/multi-select-list/MultiSelectList';
import React from 'react';
import styles from '../CaptureForm.module.scss';
import CheckboxGroup from 'component/atom/forms/checkbox/CheckboxGroup';
import Toggle from 'component/atom/forms/toggle/Toggle';
import Tooltip from 'component/Custom/tooltip/Tooltip';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import Select from 'component/atom/forms/select/select/Select';
import Input from 'component/atom/forms/input/input/Input';

const Entities = ({ formik, data }) => {
  const typeOptions = data?.data?.items?.map((item) => ({
    value: item.variableId,
    label: item.variableName,
  }));
  return (
    <div className={styles['entire-reply']}>
      <MultiSelectList
        label='Variable'
        placeholder='Select Variables'
        name='variable'
        // value={stringsToArray}
        // onChange={(e) => {
        //   const selected = e.target.value.join(',');
        //   formik.setFieldValue(
        //     `formDetails[${index}].typeSelection`,
        //     selected
        //   );
        // }}
        // onBlur={formik.handleBlur}
        options={typeOptions}
      />
      <CheckboxGroup
        key='variables'
        name='terms'
        options={typeOptions}
        // selectedValues={selectedTermIds}
        // onChange={(vals) => setSelectedTermIds(vals)}
        className={styles['checkbox-container']}
        column
        hasTag={false}
        separators={true}
        labelClassName={styles['checkbox-label']}
      />
      <div className={styles.suggest}>
        <div className={styles['tooltip-container']}>
          <p>Automatically reprompt</p>
          <Tooltip
            content='Automatic reprompts use AI to guide users in completing all required entities.
When turned off, you’ll need to set up the reprompts manually.'
            className={styles['tooltip']}
          >
            <SvgWithBranding type='info' color='#0744E1' width={14} />
          </Tooltip>
        </div>
        <Toggle
          name='autoReprompt'
          value={false}
          // onToggleChange={(e) => {
          //   formik.setFieldValue(
          //     `reassessIntent`,
          //     !formik.values.reassessIntent
          //   );
          // }}
        />
      </div>
      <div className={styles.suggest}>
        <p>Reassess Intent</p>
        <Toggle
          name='reassessIntent'
          value={formik.values.reassessIntent || false}
          onToggleChange={(e) => {
            formik.setFieldValue(
              `reassessIntent`,
              !formik.values.reassessIntent
            );
          }}
        />
      </div>
      <Select
        label='Max Retries'
        placeholder='Select Max Retries'
        options={[
          { label: '1', value: '1' },
          { label: '2', value: '2' },
          { label: '3', value: '3' },
        ]}
        name='maxRetries'
        // value={formik.values.variableId}
        // onChange={formik.handleChange}
        // error={formik.errors.variableId}
        // touched={formik.touched.variableId}
        // isLoading={isFetching}
      />
      <div className={styles.suggest}>
        <div className={styles['tooltip-container']}>
          <p>Save as Form Response</p>
          <Tooltip
            content='Toggling this on will save the collected entities in a smart form'
            className={styles['tooltip']}
          >
            <SvgWithBranding type='info' color='#0744E1' width={14} />
          </Tooltip>
        </div>
        <Toggle
          name='saveAsFormResponse'
          value={false}
          // onToggleChange={(e) => {
          //   formik.setFieldValue(
          //     `reassessIntent`,
          //     !formik.values.reassessIntent
          //   );
          // }}
        />
      </div>
      <Input label='Form Name' />
    </div>
  );
};

export default Entities;
